<!--
This file is part of the project: "Digiziege"
An app for animal-welfare-oriented goat husbandry and contactless weight estimation.
GitLab: https://gitlab.rlp.net/proj-wise2526-digiziege/digiziege

Copyright (c) 2026 Digiziege Team TH-Bingen

Description:
Companion app for welfare-oriented goat husbandry featuring contactless weight estimation via camera,
master data management and health tracking.
Built as a PWA with a local-first approach to ensure data privacy.

LICENSE INFORMATION:
This program is free software: you can redistribute it and/or modify it under the terms of the
GNU Affero General Public License as published by the Free Software Foundation,
either version 3 of the License, or (at your option) any later version.

This program is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
See the GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License along with this program.
If not, see <https://www.gnu.org/licenses/>.
-->

<template>
  <div class="fixed inset-0 z-50 flex items-center justify-center">
    <!-- Blurred Background -->
    <div 
        class="absolute inset-0 bg-black/40 backdrop-blur-sm"
        @click.stop
    ></div>
    <!-- Modal Container -->
    <div class="relative bg-[var(--color-bg)] text-[var(--color-text)] rounded-xl shadow-strong p-6 w-80 max-w-full z-10">
      <p class="mb-6 text-center font-medium">{{ message }}</p>
      <div class="flex justify-end gap-3">
        <button
          class="btn btn--secondary"
          @click.stop="$emit('cancel')"
        >
          {{ $t('common.buttons.cancel') }}
        </button>
        <button
          class="btn"
          :class="confirmButtonClass"
          @click.stop="$emit('confirm')"
        >
          {{ confirmMessage }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { computed } from 'vue'

const props = defineProps({
  message: { type: String, required: true },
  confirmMessage: { type: String, required: true },
  variant: { type: String, default: 'primary', validator: (value) => ['primary', 'warning', 'danger'].includes(value)}
})

const confirmButtonClass = computed(() => {
  switch (props.variant) {
    case 'danger':
      return 'btn--danger' //delete
    case 'warning':
      return 'btn--warning' //  edit or warning
    case 'primary':
    default:
      return 'btn--primary' // green
  }
})

</script>

<style scoped>
/* Box Shadow*/
.shadow-strong {
  box-shadow: var(--shadow-strong);
}
</style>
